// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1G6Wy","content":"Footer_content___nbDw","signUpInput":"Footer_signUpInput__3gMw3","logo":"Footer_logo__2RVT_"};